import {
  emailVerificationConstants,
  loginConstants,
  toastTypes,
  viewPathConstants,
} from "../../constants";
import { customToast } from "../../shared";
import { authService } from "../../services";
import { failure, success, withSpinner } from "./utilities";

//Getting constants
const { VERIFY_EMAIL } = emailVerificationConstants;

// Action to verify user email
const verifyEmail = (body) => (dispatch) => {
  authService.verifyEmail(body).then(
    (response) => {
      dispatch(success(response, VERIFY_EMAIL));
    },
    (error) => {
      customToast(error[0], toastTypes.ERROR);
      dispatch(failure(error[0], VERIFY_EMAIL));
    }
  );
};

//Action to verify if user email is confirmed or not
const confirmEmail = (body, navigate) => {
  return (dispatch) => {
    withSpinner(dispatch, loginConstants.LOGIN_SPINNER, () =>
      authService
        .confirmEmail(body)
        .then(
          (response) => {
            dispatch(success(response, VERIFY_EMAIL));
            if (!response.emailConfirm)
              navigate(viewPathConstants.EMAIL_VERIFICATION, {
                replace: true,
              });
          },
          (error) => {
            dispatch(failure(error[0], VERIFY_EMAIL));
          }
        )
    );
  };
};

//Exporting functions for other files
export const emailVerificationActions = {
  verifyEmail,
  confirmEmail,
};
